import React, { Component } from "react";
import {Link, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import {FormattedMessage} from 'react-intl'
import * as wActs from "../actions/website-actions";
import BuyAdsBanner from "./buyadsbanner";
import SwBanner from "./swbanner";
import SsrBanner from "./ssrbanner";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      someVal: ""
    }
  }

  componentDidMount() {
    this.H1TextBlock.innerHTML = this.props.WebPage.Page.H1TextBlock;
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }


  replaceAll(tStr,search,replacement) {
    let target = tStr;
    return target.replace(new RegExp(search, 'g'), replacement);
  }

  handleClick(e) {
    eval('$("html, body").animate({scrollTop: "0px"}, 800)');
    //return true;
  }

  getRequestInfo() {
    if(this.props.WebPage.Request) {
      let req = this.props.WebPage.Request;
      return (<span>{req.IpAddress} - [{req.CountryCode}]</span>)
    } else {
      return null;
    }
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.reload(true) //Force cache update fuckers
  }

  getMarkup() {
    if(typeof window !== "undefined") {
      return {__html: this.props.WebPage.Page.H1TextBlock}
    } else {
      return {__html: ""}
    }
  }

  stripHtml(tStr) {
    return tStr.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "");
  }

  render() {
    let showBackground = true;
    if(typeof this.props.WebPage.Settings.ShowBackgroundImage !== "undefined" && this.props.WebPage.Settings.ShowBackgroundImage === false) {
      showBackground = false;
    }

    let bStyle = {};
    if(showBackground) {
      bStyle = {backgroundImage: `url(/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/description-model.jpg)`}
    }

    let tmp = this.props.Template;
    let acc = "";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }

    return (
      <React.Fragment>

        <div className="flex-center-wrap" style={{margin: "30px 40px"}}>

          <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x200-featured']}  className="footer-banners" country={acc} >
            <BuyAdsBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")} />
          </SwBanner>
          <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x200-bottombar']}  className="footer-banners" country={acc} >
            <BuyAdsBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")} />
          </SwBanner>

        </div>

        <div style={{display: "none"}}>{this.state.someVal}</div>
        <section className="short-description nograd">
          <div className="background-model" style={bStyle}>
            <div className="container-wrapper noback">
              <article>
                {showBackground &&
                <img src={this.props.WebPage.Settings.LogoUrl.replace(".svg","_white.svg")} alt={this.props.WebPage.Settings.SeoName} />
                }
                {this.props.WebPage.PageType !== "profile" &&
                <h1>{this.props.WebPage.Page.H1Text}</h1>
                }
                <p ref={(ref) => {this.H1TextBlock = ref}} style={{overflowX: "hidden",fontSize: "1.2rem",lineHeight: "15px"}} dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.H1TextBlock}}></p>
              </article>
            </div>
          </div>
        </section>
        <footer>


          <div className="container" style={{maxWidth: "98%"}}>
            <div className="row">
              <div className="col-sm-12">
                <nav>
                  <ul>
                    {this.props.WebPage.Menu.Footer.map((v,i) => {
                      if(v.Page) {
                        return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><Link className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description} style={{textTransform: "lowercase"}}>{v.Title}</Link></li>;
                      } else {
                        if(v.Settings) {
                          return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><a className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} target="_blank" href={v.Settings.Url} title={v.Description} style={{textTransform: "lowercase"}}>{v.Title}</a></li>;
                        }
                      }
                      return null;
                    })}
                  </ul>
                </nav>

                <div className={"flex-center-wrap"} style={{marginBottom: "30px"}}>
                  {this.props.WebPage.PageType === "home" &&
                  <SsrBanner ZoneId={"home-300x100"} className="network-banners">
                    <BuyAdsBanner LocalCSS={this.props.WebPage.Settings.LocalCSS} size="300x100" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")} />
                  </SsrBanner>
                  }
                </div>



                <div className="copyright">
                  {(!wActs.isNullOrUndefined(this.props.WebPage.Page.Content.LiabilityWarning)) &&
                  <p style={{margin: "20px auto", maxWidth: "820px"}}><span>{this.props.WebPage.Page.Content.LiabilityWarning}</span></p>
                  }
                  <p><FormattedMessage id={"page.footer.copyright"} /></p>
                  <p><FormattedMessage id={"page.footer.allmodelslistedwarning"}/></p>
                  {this.props.WebPage.Settings.ShowVersionFooter &&
                    <p><FormattedMessage id={"page.footer.version"}/> - [<a onClick={(e) => {this.handleRefresh(e)}} style={{cursor: 'pointer', fontSize: "12px", textTransform: 'none'}}><FormattedMessage id={"page.refresh"}/></a>]</p>
                  }
                  {(this.props.WebPage.Settings.ShowCompanyInfoInFooter && !wActs.isNullOrUndefined(this.props.WebPage.Page.Content.CompanyInfoFooter)) &&
                    <p>{this.props.WebPage.Page.Content.CompanyInfoFooter}</p>
                  }
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }



}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Template: state.Website.Page.Template
  };
}

export default connect(mapStateToProps)(Footer);
